import { createSignal } from "solid-js";
import {
  ApiClient,
  ApiError,
  LiveClient,
  type LiveState,
  type SessionUser,
} from "@energyplatform/client";

export type Session =
  | { status: "loading" }
  | { status: "signedOut" }
  | { status: "signedIn"; user: SessionUser }
  | { status: "error"; error: unknown };

const [session, setSession] = createSignal<Session>({ status: "loading" });
export { session };

// Any 401 means the session cookie expired or was revoked: show the sign-in screen and drop cached data.
export const api = new ApiClient({
  onUnauthorized: () => {
    api.clear();
    setSession({ status: "signedOut" });
  },
});
export const live = new LiveClient("/hubs/live");

const [liveState, setLiveState] = createSignal<LiveState>("disconnected");
live.onState(setLiveState);
export { liveState };

export async function loadSession(): Promise<void> {
  try {
    setSession({ status: "signedIn", user: await api.me() });
  } catch (error) {
    if (!(error instanceof ApiError && error.status === 401)) {
      setSession({ status: "error", error });
    }
  }
}

export function startLive(): void {
  live.start().catch(() => setLiveState("disconnected"));
}

/** The host runs the OIDC flow and returns to the page the user was on. */
export function signInUrl(): string {
  return `/auth/login?returnUrl=${encodeURIComponent(location.pathname + location.search)}`;
}
